import axios from 'axios';
import API_BASE_URL from '../../Config/config';

// All TSG Nexus endpoints live under /api/nextgen-builder
// (the /nextgen-builder/* paths without /api are not routed by the API Gateway).
const NGB_API = `${API_BASE_URL}/api/nextgen-builder`;

const getEnrollment = async () => {
    try {
        const response = await axios.get(`${NGB_API}/my-enrollment`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Failed to fetch enrollment' };
    }
};

const submitEnrollment = async (enrollmentData) => {
    try {
        const response = await axios.post(`${NGB_API}/project-enrollment`, enrollmentData);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Failed to submit enrollment' };
    }
};

const getProfile = async () => {
    try {
        const response = await axios.get(`${NGB_API}/profile`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Failed to fetch profile' };
    }
};

const validateGithubUsername = async (username) => {
    try {
        const response = await axios.get(`${NGB_API}/github/validate`, { params: { username } });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Failed to validate GitHub username' };
    }
};

const getEnrollmentVersions = async (enrollmentId) => {
    try {
        const response = await axios.get(`${NGB_API}/enrollment/${enrollmentId}/versions`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Failed to fetch enrollment versions' };
    }
};

const completeProjectVersion = async (versionId) => {
    try {
        const response = await axios.patch(`${NGB_API}/project-version/${versionId}/complete`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Failed to complete project version' };
    }
};

const getGithubStatus = async (enrollmentId) => {
    try {
        const response = await axios.get(`${NGB_API}/enrollment/${enrollmentId}/github-status`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Failed to fetch GitHub status' };
    }
};

const retryGithubInvitation = async (enrollmentId, invitationId) => {
    try {
        const response = await axios.post(`${NGB_API}/enrollment/${enrollmentId}/github-retry`, { invitationId });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Failed to retry GitHub invitation' };
    }
};

const syncGithubStatus = async (enrollmentId, invitationId) => {
    try {
        const response = await axios.post(`${NGB_API}/enrollment/${enrollmentId}/github-sync`, { invitationId });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Failed to sync GitHub status' };
    }
};

const enrollmentService = {
    getEnrollment,
    submitEnrollment,
    getProfile,
    validateGithubUsername,
    getEnrollmentVersions,
    completeProjectVersion,
    getGithubStatus,
    retryGithubInvitation,
    syncGithubStatus
};

export default enrollmentService;
